<script>
  import { user, auth } from "../firebase";
  import { baseAPIUrl } from "../globals";
  import { fade } from "svelte/transition";
  import { conversion, lang } from "../store/store";

  import { router } from "tinro";
  import {
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
  } from "firebase/auth";
  user.subscribe((v) => {
    if (v == undefined) {
      return;
    }
    if (v !== null && v !== undefined) {
      router.goto("/tasks");
    }
  });

  let placeHolder1 = "This is placeholder";
  let emailInput;
  let passwordInput;
  const doLogin = () => {
    signInWithEmailAndPassword(auth, emailInput.value, passwordInput.value);
  };
</script>

<!-- <div class="u-view">
    <form on:submit|preventDefault={doLogin} class="u-box">
        <input bind:this={emailInput} placeholder="email" type="text" />
        <input
            bind:this={passwordInput}
            type="password"
            placeholder="password"
        />
        <button type="submit">Login</button>
    </form>
</div> -->

<div
  class="contentWrapper"
  in:fade={{ duration: 300, delay: 300 }}
  out:fade={{ duration: 300, delay: 0 }}
>
  <div class="mainContent">
    <div class="imageContainer"><img src="./images/icon.png" alt="" /></div>
    <h3 class="header_title">{$conversion[$lang].SigninPage[1]}</h3>

    <div class="secondary-content">
      <form on:submit|preventDefault={doLogin}>
        <input
          bind:this={emailInput}
          type="email"
          placeholder="you@exemple.com"
        />
        <input
          bind:this={passwordInput}
          type="password"
          placeholder="Password"
        />
        <h6>
          {$conversion[$lang].SigninPage[2]}
          <span><a href="/signup">{$conversion[$lang].SigninPage[3]}</a></span>
        </h6>
        <h6><a href="/">{$conversion[$lang].SigninPage[4]}</a></h6>
        <div class="buttonContainer">
          <button type="submit">{$conversion[$lang].SigninPage[5]}</button>
        </div>
      </form>
    </div>
  </div>
</div>

<style>
  /* .u-view {
        min-height: 100vh;
        width: 100%;
        display: flex;
    }
    .u-box {
        margin: auto;
    } */

  * {
    padding: 0;
    margin: 0;
  }

  .contentWrapper {
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .mainContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
    background-color: white;
    max-width: 30rem;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
  }

  .imageContainer {
    display: flex;
    justify-content: center;
  }

  .imageContainer img {
    width: 30%;
    margin-bottom: 1rem;
  }

  .mainContent h3 {
    margin-bottom: 2rem;
    font-size: 1.8em;
    font-weight: 600;
  }

  .secondary-content {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    width: 80%;
  }

  input {
    width: 100%;
    padding: 0.5rem 1rem 0.5rem 1rem;
    background-color: #ffffff;
    border: 1px solid #c3cad9;
    border-radius: 6px;
    color: #183b56;
    margin-bottom: 1rem;
    font-size: 0.8em;
  }

  .secondary-content h6 {
    font-weight: 500;
    color: rgba(149, 158, 173, 1);
    margin-bottom: 0.3rem;
  }

  .secondary-content a {
    font-weight: 500;
    color: rgba(11, 143, 251, 1);
  }

  .buttonContainer {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
  }

  .buttonContainer button {
    font-size: 0.8em;
    padding: 0.5rem 2rem 0.5rem 2rem;
    background-color: #2c8f73;
    color: white;
    border-radius: 8px;
  }

  @media only screen and (max-width: 1100px) {
    .mainContent {
      text-align: center;
    }

    .secondary-content {
      width: 100%;
    }
  }

  .header_title {
    text-align: center;
  }
</style>
